export default "__VITE_ASSET__z5syaBlh__"